export const ChevronRight = ({...rest}) => {
  const style = {fill: 'currentColor', maxWidth: '100%', maxHeight: '100%'};
  return (
    <div {...rest}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
        <path
          d="M7.86863 20.1314C7.24379 19.5066 7.24379 18.4935 7.86863 17.8687L13.7373 12L7.86863 6.1314C7.24379 5.50656 7.24379 4.49349 7.86863 3.86865C8.49347 3.24381 9.50653 3.24381 10.1314 3.86865L17.1314 10.8687C17.7562 11.4935 17.7562 12.5066 17.1314 13.1314L10.1314 20.1314C9.50653 20.7562 8.49347 20.7562 7.86863 20.1314Z"
          fill="currentColor"
        />
      </svg>
    </div>
  )
}